<template>
  <div class="quiz__play">
    <h1>{{ $t("module.quiz") }}</h1>
    <div class="played" v-if="hasPlayed">
      <h2>{{ $t("module.quizPlayed") }}</h2>
    </div>
    <div v-else-if="!result" class="questions">
      <h2>{{ `${questions[questionIndex].text}` }}</h2>
      <!-- <span>Select the correct answer</span> -->
      <div class="list">
        <ul>
          <li
            v-for="answer in questions[questionIndex].answers"
            :key="answer.id"
            :class="answer.isCorrect ? 'selected' : ''"
            @click="answer.isCorrect = !answer.isCorrect"
          >
            <div>
              <span>{{ answer.text }}</span>
              <i
                v-if="answer.isCorrect"
                class="mdi mdi-check-circle-outline circle-icon"
              ></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="navigation">
        <b-button
          v-if="questionIndex > 0"
          @click="questionIndex--"
          class="button is-info is-rounded action-button"
          icon-left="arrow-left-bold"
        >
          {{ $t("module.back") }}
        </b-button>
        <b-button
          v-if="questions.length - 1 > questionIndex"
          @click="nextQuestion()"
          class="button is-info is-rounded action-button"
          icon-right="arrow-right-bold"
        >
          {{ $t("module.next") }}
        </b-button>
        <b-button
          v-if="questions.length - 1 <= questionIndex"
          @click="nextQuestion()"
          class="button is-success is-rounded action-button"
        >
          {{ $t("module.save") }}
        </b-button>
      </div>
    </div>
    <div v-if="result && !showSummary" class="result">
      <div v-if="showPyro" class="pyro">
        <div class="before"></div>
        <div class="after"></div>
      </div>
      <span class="result-info">{{
        result.correctAnswered === questions.length
          ? $t("module.allAnswersCorrect", { points: result.points })
          : $t("module.correctAnswers", {
              correctAnswered: result.correctAnswered,
              length: questions.length,
              points: result.points
            })
      }}</span>
      <button
        @click="showSummary = true"
        class="button is-success is-rounded action-button summary"
      >
        {{ $t("module.showResults") }}
      </button>
    </div>

    <div v-if="showSummary" class="summary">
      <h2>{{ `${result.correctQuestions[questionIndex].text}` }}</h2>
      <div class="list">
        <ul>
          <li
            v-for="answer in questions[questionIndex].answers"
            :key="answer.id"
          >
            <div>
              <span>{{ answer.text }}</span>
              <i :class="showIcon(answer)"></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="navigation">
        <b-button
          v-if="questionIndex > 0"
          @click="questionIndex--"
          class="button is-info is-rounded action-button"
          icon-left="arrow-left-bold"
        >
          {{ $t("module.back") }}
        </b-button>
        <b-button
          v-if="result.correctQuestions.length - 1 > questionIndex"
          @click="questionIndex++"
          class="button is-info is-rounded action-button"
          icon-left="arrow-right-bold"
        >
          {{ $t("module.next") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "play",
  data: () => {
    return {
      questionIndex: 0,
      questions: [],
      result: null,
      showSummary: false,
      hasPlayed: null,
      showPyro: false
    };
  },
  props: {
    post: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["user", "tenant"])
  },
  methods: {
    ...mapActions(["checkQuiz", "updateStats"]),
    showIcon(answer) {
      let answers = this.result.correctQuestions[this.questionIndex].answers;
      if (answers) {
        let filledAnswer = answers.find(o => {
          return o.id === answer.id;
        });

        if (filledAnswer.isCorrect) {
          return "mdi mdi-check-circle-outline circle-icon";
        } else if (filledAnswer.isCorrect !== answer.isCorrect) {
          return "mdi mdi-close-circle-outline circle-icon";
        } else {
          return "";
        }
      }
    },
    nextQuestion() {
      if (this.questions.length - 1 > this.questionIndex) {
        this.questionIndex++;
      } else {
        this.post.quiz.questions = this.questions;
        this.checkQuiz(this.post).then(result => {
          this.result = result;
          this.questionIndex = 0;

          if (result.correctAnswered === this.questions.length) {
            this.showPyro = true;

            setTimeout(() => {
              this.showPyro = false;
            }, 5000);
          }

          if (this.user) {
            if (!this.user.quiz) {
              this.user.quiz = {
                [this.tenant.tenantId]: { points: 0, ids: [] }
              };
            }

            let selectedQuiz = this.user.quiz[this.tenant.tenantId];

            selectedQuiz.points = selectedQuiz.points
              ? selectedQuiz.points + result.points
              : result.points;

            if (selectedQuiz.ids) {
              selectedQuiz.ids.push(this.post.id);
            } else {
              selectedQuiz.ids = [this.post.id];
            }

            this.user.quiz[this.tenant.tenantId] = selectedQuiz;

            this.updateStats({
              quiz: this.user.quiz,
              type: "quiz"
            });
          }
        });
      }
    }
  },
  created() {
    this.questions = this.post.quiz.questions;

    if (this.user && this.user.quiz) {
      if (!this.user.quiz[this.tenant.tenantId]) {
        this.user.quiz[this.tenant.tenantId] = { points: 0, ids: [] };
      }

      this.hasPlayed = this.user.quiz[this.tenant.tenantId].ids.find(
        o => o === this.post.id
      );
    }
  }
};
</script>

<style></style>
